<script>
import ListField from './ListField.vue'
import MembersRemovalUpload from './components/MembersRemovalUpload.vue'
import ImportStats from './components/ImportStats.vue'
import ListImportProgress from './ListImportProgress.vue'
import ListPreloader from "./components/ListPreloader.vue";
import ListExportButton from "./ListExportButton.vue";
import ListCheckButton from "./ListCheckButton.vue";
import StateBadge from "./components/StateBadge.vue";

import BaseInputApp from './components/BaseInputApp.vue'

const axios = require('axios');

export default {

  mixins: [BaseInputApp],

  components: {
    StateBadge, ListPreloader, MembersRemovalUpload, ListImportProgress, ListField, ListExportButton, ListCheckButton, ImportStats
  },
  data(){
    return {
      view: null,
      items: [],
      lastLoadedData: null,
      fields: [],
      isLoading: false,
      isInited: false,
      name: '',
      owner: null,
      rootOwner: null,
      list: null,
      uuidsToAdd: [],
      hasStates: false,

      limit: 10,
      page: 1,
      sort: null,
      total: null,
      totalUnfiltered: null,
      errors: null,

      limits: [10, 25, 50, 100],
      loadedLimit: 10,
      loadedPage: 1,
      states: null,
      state: null,
      group: null,
      query: null,
      requestUpdateId: null,
      uploadedImportFile: null,
      isValidating: false,
      allowValidate: true,
    }
  },
  watch:{
    limit(){
      this.page = 1;
      this.requestUpdate(100)
    },
    page(){
      this.requestUpdate(100)
    },
    query(){
      this.requestUpdate()
    },
    state(){
      this.requestUpdate(100)
    },
    group(){
      this.requestUpdate(100)
    },
    sort(){
      this.requestUpdate(100)
    }
  },
  mounted() {

    this.name = this.$el.parentElement.dataset.name
    this.list = this.$el.parentElement.dataset.list
    this.owner = this.$el.parentElement.dataset.owner || null
    this.rootOwner = this.$el.parentElement.dataset.rootOwner || null
    this.updateList()
  },
  methods: {
    token(){
      return this.$el.parentElement.dataset.token
    },
    doListTransition(transition){

      let itemId = this.rootOwner.split(':')[1];

      this.openModal(`${this.basePath()}applications/change_subject_state/id.${itemId}/?subject=Application.Item&transition=${transition.id}`, {
        afterClose: function () {
          this.updateList()
        }.bind(this),
      })
    },
    addNewListItem(){
      const urlIdentityParams = {
        _display: 'iframe',
        list: this.list,
        owner: this.owner,
        rootOwner: this.rootOwner,
      };
      const url = `${this.basePath()}lists/add_item?` + $.param(urlIdentityParams);
      this.openModal(url, {
        afterClose: function () {
          this.updateList()
        }.bind(this),
        afterLoad: function (instance, slide){
          let $iframe = typeof slide.iframeEl === 'undefined' ? slide.$iframe : $(slide.iframeEl)
          $iframe.on('load', function (e) {
            e.currentTarget.contentWindow.addEventListener('message', function(event) {
              this.uuidsToAdd.push(event.data.uuid)
              //$(this.$root.$el.parentElement).trigger('change');
              instance.close();
              this.updateList()
            }.bind(this))
          }.bind(this));

        }.bind(this),
        mainClass: "fancybox--wide"
      })
    },
    editItem(item){

      const urlIdentityParams = {
        _display: 'iframe',
        list: this.list,
        uuid: item.uuid,
        id: item.id,
        rootOwner: this.rootOwner,
      };

      const url = `${this.basePath()}lists/edit_item?` + $.param(urlIdentityParams);
      this.openModal(url, {
        afterClose: function () {
          this.updateList()
        }.bind(this),
        afterLoad: function (instance, slide){
          let $iframe = typeof slide.iframeEl === 'undefined' ? slide.$iframe : $(slide.iframeEl)
          $iframe.on('load', function (e) {
            e.currentTarget.contentWindow.addEventListener('message', function() {
              //$(this.$root.$el.parentElement).trigger('change');
              instance.close();
              this.updateList()
            }.bind(this))
          }.bind(this));

        }.bind(this),
        mainClass: "fancybox--wide"
      })
    },
    // deleteItem(item, confirmMessage){
    //
    //
    //   global.openConfirmModal({
    //     title: this.$t('confirm:delete item'),
    //     ok: {
    //       title: this.$t('applications: delete list item'),
    //       icon: 'ph ph-trash',
    //       callback: () => {
    //         const urlIdentityParams = {
    //           _display: 'iframe',
    //           list: this.list,
    //           uuid: item.uuid,
    //           confirmMessage: confirmMessage || this.$t('confirm:delete item'),
    //         };
    //         const url = `${this.basePath()}lists/delete_list_item?` + $.param(urlIdentityParams);
    //
    //         this.openModal(url, {
    //           afterClose: function () {
    //             this.updateList()
    //           }.bind(this),
    //           afterLoad: function (instance, slide){
    //             let $iframe = typeof slide.iframeEl === 'undefined' ? slide.$iframe : $(slide.iframeEl)
    //             $iframe.on('load', function (e) {
    //               e.currentTarget.contentWindow.addEventListener('message', function() {
    //                 instance.close();
    //                 this.updateList()
    //               }.bind(this))
    //             }.bind(this));
    //
    //           }.bind(this)
    //         })
    //       }
    //     }
    //   })
    // },
    identityParams(){
      return {
        list: this.list,
        uuid: this.uuidsToAdd,
        owner: this.owner,
        name: this.name
      }
    },
    requestUpdate(delay){
      clearTimeout(this.requestUpdateId)
      this.requestUpdateId = setTimeout(() => this.updateList(), delay ?? 1000)
    },
    updateList(){
      this.isLoading = true
      axios.get(`${this.basePath()}lists/get_list_items`, {
        params: {
          ...this.identityParams(),
          ...{
            _limit: this.limit,
            _page: this.page,
            _sort: this.sort,
            query: this.query,
            state: this.state,
            group: this.group,
          }
        }
      })
        .then( response => {
          this.lastLoadedData = response.data

          // if(response.data._applicationState === 'submitted'){
          //   window.location.reload()
          // }


          this.fields = response.data.fields;
          this.items = response.data.items;
          this.hasStates = response.data.hasStates;
          this.total = response.data._total;
          this.totalUnfiltered = response.data._totalUnfiltered;
          this.loadedLimit = response.data._limit;
          this.loadedPage = response.data._page;
          this.states = response.data._states;

          // Tikrinam ar naudotojas nėra neegzistuojančiam psl (tuo atvieju kai buvo ištrintas paskutiniam puslapyje esantis įrašas)
          const totalPages = Math.ceil(this.total / this.loadedLimit);
          if (this.page > totalPages && totalPages > 0) {
            this.page = totalPages;
            return;
          }

          if(this.state && this.states && !this.states.some( s => s.id === this.state)){
            this.state = null;
            return;
          }

          this.uploadedImportFile = response.data._upload;
          this.isValidating = response.data._isValidating;

          if(response.data._errors){
            this.errors = response.data._errors.join(', ')
          }else{
            this.errors = null
          }


          if(this.uploadedImportFile && ['import_queued', 'import_progress'].indexOf(this.uploadedImportFile.state) >=0){
            this.view = 'import'
          }else if(this.totalUnfiltered > 0){
            this.view = 'list'

            if(this.isValidating){
              this.requestUpdate(5000)
            }

          }else{
            this.view = 'upload'
          }
        })
        .catch( error => {
          // handle error
        })
        .finally( () => {
          this.isLoading = false
          this.isInited = true
        })
    },
    openModal(url, ops){

      if (typeof sysOpenModal !== 'undefined'){
        //CMS modal
        sysOpenModal(url, 'iframe', ops)
      }else if (typeof openModal !== 'undefined'){
        //front modal
        let events = {}
        if(ops.afterClose){
          events.destroy = ops.afterClose
          delete ops.afterClose;
        }
        if(ops.afterLoad){
          events.loading = ops.afterLoad
          delete ops.afterLoad;
        }
        openModal(url, 'iframe', null, ops, events)
      }
    },
    setPage(page){
      this.page = page
    },
    getSortIcon(field){

      if(`-${field}` === this.sort){
        return 'ph ph-arrow-down'
      }else if (`+${field}` === this.sort){
        return 'ph ph-arrow-up'
      }else{
        return 'ph ph-arrows-down-up'
      }
    },
    setSortBy(field){
      if(this.sort === `-${field}`){
        this.sort = `+${field}`
      }else{
        this.sort = `-${field}`
      }
    },
    getItemTooltip(item){
      if(item.errors['attributes[PersonalCode:member]']){
          return item.errors['attributes[PersonalCode:member]'];
      }
      return null;
    },
    requestMediaDelete(){
      axios.postForm(`${this.basePath()}api/media/delete`, {
        _token: this.token(),
        hash: this.uploadedImportFile.hash,
      }).catch( error => {
        // handle error
      })
      this.uploadedImportFile = null;
    },
  },
  computed: {
    totalPages(){
      return Math.ceil(this.total / this.loadedLimit);
    },
  }

}

</script>
<template>
  <div class="list-wrap position-relative form-group" :class="{'is-loading': isLoading, 'has-error': this.errors !== null}" :data-input_name='this.name'>
    <p class="alert alert-outline-danger d-flex gap-2 align-items-center" v-if="uploadedImportFile?.state === 'import_failed'">
      <i class="ph-fill ph-warning"></i>
      <span class="flex-fill">
        {{ this.uploadedImportFile?.parameters?.error }}
      </span>
      <button type="button" class="btn btn-link d-flex p-0" @click="requestMediaDelete">
        <i class="ph ph-x-circle"></i>
      </button>
    </p>

    <p class="alert alert-outline-danger d-flex gap-2 align-items-center" v-if="errors !== null && view === 'upload'">
      <i class="ph-fill ph-warning"></i>
      {{ this.errors }}
    </p>

    <!--
    <div class="alert alert-outline-danger d-flex gap-2 align-items-center" v-if="this.errors !== null">
      <i class="ph-fill ph-warning"></i>
      <div class="invalid-feedback d-block">{{ this.errors }}</div>
    </div>
    -->

    <MembersRemovalUpload media-type="Lists.ImportFile" :item-id="this.list" :input-name="this.owner"
                      @back="this.view = null;this.requestUpdate(100)"
                      @addListItem="this.addNewListItem()"
                      @uploadError="(error) => { this.errors = error }"
                      v-if="this.view==='upload'"
                      :list="this.list"
                      :owner="this.owner"
    />
    <ListImportProgress
                        v-if="this.view==='import'"
                        :uploadedImportFile="this.uploadedImportFile"
                        @back="this.view = null;this.requestUpdate(100)"
    />

    <template v-if="this.view==='list'">

      <p>{{ $t('lists: membership removal submit disclaimer') }}</p>

      <ImportStats :last-loaded-data="this.lastLoadedData" v-if="this.lastLoadedData?._totalUnfiltered > 0"/>

      <div class="list-errors alert alert-outline-warning d-flex gap-2 align-items-center" v-if="this.errors !== null">
        <i class="ph-fill ph-warning"></i>
        <div class="d-block">{{ this.errors }}</div>
      </div>

      <div class="bg-light rounded-3 border p-3 mb-3"  v-if="this.totalUnfiltered > 0">
        <div class="d-flex gap-2  flex-column flex-md-row">
          <div class="flex-fill d-flex gap-2 flex-column flex-md-row">
            <div class="w-50 list-item-search-wrapper">
              <label for="list-item-search" class="form-label">{{ $t('search') }}</label>
              <input type="text" class="form-control" id="list-item-search" :placeholder="this.$t('lists: enter search fragment')" v-model="this.query">
            </div>
            <div class="w-50">
              <label for="list-item-state" class="form-label">{{ $t('lists: item state') }}</label>
              <div class="vue-select-wrap">
                <select id="list-item-state" class="form-control" v-model="this.group">
                  <option v-for="s in this.lastLoadedData?._group" :value="s.id">
                    {{ s.title }}
                  </option>
                </select>
                <i class="ph-fill ph-caret-down select-caret" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div>
            <label class="form-label">&nbsp;</label>
            <button class="btn btn-dark d-block" type="button" @click="this.query = null; this.state = null">
              {{ $t('filters: clear') }}
            </button>
          </div>
        </div>
      </div>

      <div class="gap-2 d-flex justify-content-end w-100 mb-3 list-buttons">
        <ListExportButton :list="this.list" :owner="this.owner" v-if="this.total > 0" :filter="{query: this.query, state: this.state, group: this.group}"/>
      </div>

      <div class="p-5 text-center" v-if="items.length === 0 && this.totalUnfiltered > 0">
        <div class="fw-bold fs-16">{{ $t('lists: no items found by filter')}}</div>
        <div class="fs-16">{{ $t('lists: no items found by filter description')}}</div>

        <div>
          <a class="btn btn-primary mt-3" @click="this.query = null; this.state = null;">
            {{ $t('filters: clear filter')}}
          </a>
        </div>
      </div>

      <div class="table-rounded-wrapper border-bottom-0 rounded-bottom-0" v-if="items.length > 0">
        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <!--<th>ID</th>-->
              <th>{{ $t('lists: item no') }}</th>
              <th v-for="field in fields" :class="{orderable: field.orderable}">
              <span v-if="field.orderable">
                <a type="button" @click="setSortBy(`att_${field.code}`)" :class="{'ordering-active' : this.sort?.endsWith(field.code)}">
                  {{ field.title }}
                  <i :class="this.getSortIcon(`att_${field.code}`)"></i>
                </a>
              </span>
                <span v-if="!field.orderable">{{ field.title }}</span>
              </th>
              <th v-if="hasStates" class="orderable">
              <span>
                <a type="button" @click="setSortBy(`state`)" :class="{'ordering-active' : this.sort?.endsWith('state')}">
                  {{ $t('lists: validation results') }}
                  <i :class="this.getSortIcon(`state`)"></i>
                </a>
              </span>
              </th>
              <th>
                {{ $t('actions title') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in items">
              <!--
              <td>
                #{{ item.id }} - {{ item.uuid }}
                <input type="hidden" :name="`${name}[]`" :value="item.uuid">
              </td>
              -->
              <td>{{ (loadedLimit * (loadedPage - 1) ) + index + 1 }}</td>
              <td v-for="field in fields">
                <ListField :field="field" :item="item" :owner="owner" :list="list" @updated="this.updateList"
                           @saving="this.isLoading = true" @saved="this.isLoading = false"/>
              </td>
              <td v-if="hasStates">
                <StateBadge :state="item.state"/>
              </td>
              <td class="action">
                <div class="actions dropdown text-center">
                  <button class="btn btn-link p-0 border-0 text-dark hover-dark" type="button" id="actionsDropdown-88" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Actions" data-bs-popper-config='{ "strategy" : "fixed" }'>
                    <i class="ph ph-dots-three-vertical" aria-hidden="true"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="actionsDropdown-88" style="">
                    <li>
                      <a class="dropdown-item d-flex align-items-center gap-2" type="button" @click="editItem(item)"><i class="ph ph-pencil"></i> {{ $t('lists: edit item') }}</a>
                      <a class="dropdown-item d-flex align-items-center gap-2" type="button" @click="deleteItem(item)"><i class="ph ph-trash"></i> {{ $t('lists: delete item') }}</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="flex-column flex-md-row d-flex align-items-center justify-content-between w-100 bg-light rounded-3 p-3 rounded-top-0 border border-top-0" v-if="this.totalUnfiltered > 0">
        <div>
          {{ $t('total of')}} <strong>{{ this.total ?? '' }}</strong>
        </div>
        <nav  v-if="this.total > this.loadedLimit">
          <ul class="pagination my-0">
            <li class="page-item"><a class="page-link align-items-center gap-2" type="button" @click="setPage(this.page - 1)" :class="{'disabled': this.page <= 1}"><i class="ph ph-arrow-left"></i> {{ $t('prev') }}</a></li>
            <template v-for="p in totalPages">
              <li v-if="p===totalPages && this.loadedPage < this.totalPages - 2"><span class="page-link">...</span></li>

              <li class="page-item" :class="{'active': p === (this.page)}" v-if="Math.abs(this.loadedPage - p) < 2 || p === 1 || p === this.totalPages ">
                <a class="page-link" type="button" @click="setPage(p)">{{ p }}</a>
              </li>
              <li v-if="p===1 && this.loadedPage > 3"><span class="page-link">...</span></li>

            </template>
            <li class="page-item"><a class="page-link d-flex align-items-center gap-2"  type="button" @click="setPage(this.page + 1)" :class="{'disabled': this.page >= this.totalPages}">{{ $t('next') }} <i class="ph ph-arrow-right"></i></a></li>
          </ul>
        </nav>
        <div class="d-flex align-items-center gap-2 item-per-page-select">
          {{ $t('items per page') }}
          <select v-model="this.limit" class="form-control form-control-sm">
            <option v-for="l in this.limits" :value="l">
              {{ l }}
            </option>
          </select>
        </div>
      </div>

      <div class="gap-2 d-flex justify-content-end w-100 my-5">
        <button @click="this.view='upload'" type="button" class="btn btn-light d-flex gap-2 align-items-center"><i class="ph ph-plus"></i> {{ $t('lists: upload import') }}</button>
        <ListCheckButton :list="this.list" :owner="this.owner" v-if="this.total > 0" :isValidating="this.isValidating" @onUpdate="this.updateList" :label="this.$t('lists: check members data')"/>

        <button v-for="t in this.lastLoadedData._transitions" @click="this.doListTransition(t)" type="button" class="btn btn-primary d-flex gap-2 align-items-center">{{ t.title }} <i :class="t.icon"></i></button>

      </div>
      <ListPreloader v-if="isLoading"/>
    </template>
  </div>

  <ListPreloader text="lists: loading items list" position="relative" height="400px" v-if="this.view === null"/>


</template>

<style scoped>
  .list-wrap:not(.has-error) > .list-errors{
    display: none!important;
  }

  .list-wrap.is-loading{
    > *:not(.preloader-wrap){
      opacity: 0.2;
    }
  }

/*
  .list-wrap{
    min-height: 400px;
    &.is-loading > *:not(.list-preloader){
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .list-preloader{
    top: 200px;
  }

 */
</style>